import React from "react";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useSeo } from "@/lib/seo";

export default function PaymentCancel() {
  useSeo("Payment Cancelled", "Your payment was cancelled.");
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="bg-white rounded-[2rem] soft-shadow p-8 sm:p-12 max-w-lg w-full text-center">
        <ShoppingBag className="w-16 h-16 text-[#FFD93D] mx-auto" />
        <h1 className="font-display font-extrabold text-2xl text-[#19324A] mt-5">No worries — nothing was charged.</h1>
        <p className="text-[#19324A]/65 mt-3">Your bag is still safe and sound, ready whenever you are.</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-7">
          <Link to="/cart" className="btn-primary">Back to Bag</Link>
          <Link to="/shop" className="btn-outline">Keep Shopping</Link>
        </div>
      </div>
    </div>
  );
}
